import React, { useState, useEffect } from 'react';
import ReactDomConfetti from 'react-dom-confetti';

const DEFAULT_CONFIG = {
  angle: 90,
  spread: '63',
  startVelocity: '50',
  elementCount: '100',
  dragFriction: 0.1,
  duration: 3000,
  stagger: '8',
  width: '10px',
  height: '10px',
  colors: ['#4A90E2', '#EB3068', '#F9CF36', '#66B0B7', '#72BC51'],
};

export default function Confetti({ config = {} }) {
  // https://github.com/daniel-lundin/react-dom-confetti/issues/16
  const [showConfetti, setShowConfetti] = useState(false);
  useEffect(() => {
    setTimeout(() => setShowConfetti(true), 0);
  }, []);

  const mergedConfig = {
    ...DEFAULT_CONFIG,
    config,
  };

  return (
    <div className="pos-a Confetti-wrapper">
      <ReactDomConfetti active={showConfetti} config={mergedConfig} />
    </div>
  );
}
